import Vue from 'vue'
import VueI18n from 'vue-i18n'

import { globalConfig } from '@/config'
import { messages } from '@/localization'

Vue.use(VueI18n)

// Localization
const i18n = new VueI18n({
    locale: globalConfig.lang,
    messages,
})

export { i18n }
